module.exports = __webpack_public_path__ + "img/icon6.231e03e6.svg";